// blog data

export const Code = [
    {
        id:1,
        name:"MERN Stack Chat Application",
        tags:["cloudinary","password hashing","mongoDB","Jwt-Authentication","socket.io","Chakra-UI"],
        date:"13 May, 2021",
        imgSrc:"https://img.freepik.com/free-vector/illustration-speech-bubble_53876-5625.jpg?w=740",
        link:"https://github.com/adarsh4567/Mern-Stack-Chat-App"
    },
    {
        id:2,
        name:"React Js Movies Website",
        tags:["react","moviesDB-api","Material-UI"],
        date:"5 July, 2021",
        imgSrc:"https://img.freepik.com/free-psd/film-strip-with-butter-popcorn_23-2148470110.jpg?w=1060",
        link:"https://github.com/adarsh4567/Entertainment"
    },
    {
        id:3,
        name:"Crypto-Currency Tracker App suing React Js",
        tags:["react","Material-UI","Crypto-Api"],
        date:"6 July, 2021",
        imgSrc:"https://img.freepik.com/free-vector/gradient-crypto-logo-collection_23-2148979930.jpg?w=1060",
        link:"https://github.com/adarsh4567/Crypto-Zone"
    },
    {
        id:4,
        name:"Recipes Search Website using Api",
        tags:["HTML","CSS","Javascript"],
        date:"26 May, 2021",
        imgSrc:"https://img.freepik.com/free-vector/healthy-food-background_23-2148123964.jpg?w=740",
        link:"https://github.com/adarsh4567/Recepie-App"
    },
    {
        id:5,
        name:"Tour And Travel Website",
        tags:["HTML","CSS","Animation-On-Scroll-Library"],
        date:"3 Feb, 2021",
        imgSrc:"https://img.freepik.com/free-vector/travel-sale-with-photo-landing-page_23-2148657437.jpg?w=1060",
        link:"https://github.com/adarsh4567/Tour-And-Travel-Website"
    },
    {
        id:6,
        name:"FaceBook Ui clone with Javascript",
        tags:["Html","css","Javascript"],
        date:"5 Jan, 2021",
        imgSrc:"https://img.freepik.com/free-vector/facebook-background-with-likes-hearts_23-2147855032.jpg?w=740",
        link:"https://github.com/adarsh4567/Social-media-Website-"

    },
   
    {
        id:7,
        name:"Windows-11 UI Design",
        tags:["HTML","Css","javascript"],
        date:"16 May, 2021",
        imgSrc:"https://img.freepik.com/free-vector/isometric-people-working-with-technology_52683-19078.jpg?w=1060",
        link:"https://github.com/adarsh4567/Windows-11-Interface"
    },
    {
        id:8,
        name:"Spark-Foundation Task Project",
        tags:["HTML","CSS","Javascript","Payment-Gateway"],
        date:"26 May, 2021",
        imgSrc:"https://img.freepik.com/free-photo/closeup-diverse-people-joining-their-hands_53876-96081.jpg?w=1380",
        link:"https://github.com/adarsh4567/spark-foundation-task"
    },
  
] 